export default __webpack_public_path__ + "static/media/regulatory--end-of-pedestrians-only--g2.55157960.png";